import React, { CSSProperties, KeyboardEvent, FC, FormEvent, MouseEvent } from "react"
import styled from 'styled-components'

interface IAudioPlayerSliderProps {
  className?: string
  passedColor: string
  remainingColor: string
  value: number
  step: number
  max: number
  disabled: boolean
  onUpdateStart?: (newValue: number) => void
  onUpdateEnd?: (newValue: number) => void
}

interface IAudioPlayerInputCssProperties extends CSSProperties {
  '--value': number;
}

interface IPlayerInputProps {
  passedColor: string
  remainingColor: string
}

const PlayerInput = styled.input<IPlayerInputProps>`
  --min: 0;
  --range: calc(var(--max) - var(--min));
  --ratio: calc((var(--value) - var(--min)) / var(--range));
  --sx: calc(var(--ratio) * 100%);
  height: 16px;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
  :focus {
    outline: none;
  }
  ::-webkit-slider-runnable-track {
    background: linear-gradient(${({passedColor}) => `${passedColor},${passedColor}`}) 0/var(--sx) 100% no-repeat, ${({remainingColor}) => remainingColor};
    border-radius: 2px;
    height: 4px;  
  }
  ::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    margin-top: -4px;
    border-radius: 50%;
    background-color: transparent;
    box-shadow: none;
    height: 12px;
    width: 12px;
  }
  :hover::-webkit-slider-thumb {
    background-color: black;
  }
  ::-moz-range-track {
    background: linear-gradient(${({passedColor}) => `${passedColor},${passedColor}`}) 0/var(--sx) 100% no-repeat, ${({remainingColor}) => remainingColor};
    border-radius: 2px;
    height: 4px;
  }
  ::-moz-range-thumb {
    border: none;
    border-radius: 50%;
    background-color: transparent;
    box-shadow: none;
    height: 12px;
    width: 12px;
  }
  :hover::-moz-range-thumb {
    background-color: black;
  }
`

const AudioPlayerSlider: FC<IAudioPlayerSliderProps> = ({
  className,
  passedColor,
  remainingColor,
  max,
  value,
  step,
  disabled,
  onUpdateStart,
  onUpdateEnd,
}) => {

  const onInput = (event: FormEvent<HTMLInputElement>) => {
    if (onUpdateStart) {
      const target = event.target as HTMLInputElement
      const value = Number(target.value)
      onUpdateStart(value)
    }
  }

  const handleUpdateEnd = (event: MouseEvent<HTMLInputElement> | KeyboardEvent<HTMLInputElement>) => {
    if (onUpdateEnd) {
      const target = event.target as HTMLInputElement
      const value = Number(target.value)
      onUpdateEnd(value)
    }
  }

  return <PlayerInput 
    type="range"
    min={0}
    max={max}
    step={step}
    style={{
      '--value': value,
      '--max': max,
    } as IAudioPlayerInputCssProperties}
    className={className} 
    value={value}
    passedColor={passedColor}
    remainingColor={remainingColor}
    onInput={onInput}
    onMouseUp={handleUpdateEnd}
    onKeyUp={handleUpdateEnd}
    disabled={disabled}
  />
}

export default AudioPlayerSlider